import React from "react";
// import TextField from '@material-ui/core/TextField';
// import Grid from "@material-ui/core/Grid";
// import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import AppBar from "../../header/index";
import {useRedirect} from "react-admin";
import ButtonBase from '@material-ui/core/ButtonBase';


import AppProvider from "../../bootstrap/index";
import { Card } from "@material-ui/core";
import {CardHeader,CardContent} from "@material-ui/core";
const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 345
  }
  
}));



const UpcomingAppointments = props => {
  const redirect=useRedirect()
  const classes = useStyles();
  return (
    <div className={classes.coverBackgroundContainer}>
    
      <Container component="main" maxWidth="xs">
        <Typography
          component="h6"
          variant="h6"
          style={{ marginTop: "20%", minWidth: "100%", textAlign: "center" }}
        >
         Upcoming Appointments
        </Typography>
        <ButtonBase onClick={()=>redirect("./moreupcomingappointments")}>
        <Card style={{ marginTop: 15,height:"200px", width:"330px", textAlign:"left"  }}>
        
          <CardHeader
            title="Appointment: Title"
          />
          <CardContent>
         <h4> metor</h4>
         <h4> metoee</h4>
             <h4> shedule</h4>
          </CardContent>

         
       
        </Card>
        </ButtonBase>
        <ButtonBase onClick={()=>redirect("./moreupcomingappointments")}>
        <Card  style={{ marginTop: 15,height:"200px", width:"330px", textAlign:"left"  }}>
          <CardHeader
            title="Appointment: Title"
          />
          <CardContent>
         <h4> metor</h4>
         <h4> metoee</h4>
             <h4> shedule</h4>
          </CardContent>

          
        </Card>
        </ButtonBase>

       
        <AppProvider>
          <AppBar />
        </AppProvider>
      </Container>
    </div>
  );
};
export default UpcomingAppointments;
